import {
  AiSummariesRoute,
  AiSummariesPathName,
} from '@/modules/ta/chatgptsummaries/chatgptsummaries.constants';
import { ChatGptSummaryRouteConfig } from '@/modules/ta/chatgptsummaries/ChatGptSummaryRouteConfig';

export const router = ChatGptSummaryRouteConfig.factory([
  {
    path: `/${AiSummariesRoute.AISUMMARIES}`,
    name: AiSummariesPathName.AISUMMARIES,
    component: () =>
      import(/* webpackChunkName: "chatgptsummaries-page" */ './pages/ChatGptSummariesPage.vue'),
  },
]);
